export const routesRaporMesai = [
  {
    path: "/rapor_mesai",
    name: "rapor_mesai",
    component: () => import("@/views/proje_alt/rapor_mesai/index.vue"),
    meta: {
      public: false,
      title: "proje_alt.Mesai Rapor",
      yetki: { k: [1012202] },
    },
  },
]
